export default "__VITE_ASSET__1b50d5c9__"